import styled from 'styled-components';

import { TopNavMenu } from './TopNavMenu';

const TopNavCollapsibleMenu = styled(TopNavMenu).attrs({
   'data-rcl-collapsible-menu': true,
})`
   overflow: auto;
`;

export { TopNavCollapsibleMenu };
